import Column from '@components/Column';
import Description from '@components/Description';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import useProject from '@hooks/useProject';
import { useTranslation } from 'react-i18next';

function DisposeDescription() {
    const { t } = useTranslation('accountTermination');
    const project = useProject();
    return (
        <Description>
            <Column fullWidth spacing={1.5}>
                {project?.features.ppCardEnabled && (
                    <DisposeRow label={t('dispose.prepaidCardBalance')}
                        value='5,000' />
                )}
                <DisposeRow label={t('dispose.stamp')}
                    value={`8${t('dispose.count')}`} />
                <DisposeRow label={t('dispose.coupon')}
                    value={`3${t('dispose.count')}`} />
            </Column>
        </Description>
    );
}

interface RowProps {
    label: string;
    value: string;
}

function DisposeRow({ label, value }:RowProps) {
    return (
        <Row fullWidth
            justify='space-between' >
            <Text color={colors.gray6}>{label}</Text>
            <Text
                color={colors.gray7}
                fontWeight='bold' >
                {value}
            </Text>
        </Row>
    );
}

export default DisposeDescription;
